
import Vue from 'vue'
import AppMixin from '@/_mixins/app'

import { HseContact } from '@/views/Project/HSE/types/hseContact'

import EditorViewer from '@/_components/editorJS/viewer/viewer.vue'
import InlineUser from '@/views/User/components/inlineUser/inlineUser.vue'

const HseContact = Vue.extend({
    mixins: [AppMixin],
    components: { EditorViewer, InlineUser },
    props: {
        hseContact: {
            type: Object as () => HseContact,
            required: true,
        },
        onlyPublic: {
            type: Boolean,
            default: false,
        },
        index: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {}
    },

    methods: {},
})

export default HseContact
